<template>
  <v-container v-if="show" fluid>
    <v-row>
      <v-col class="notification-col">
        <v-btn :disabled="isLoadingSingleNotificationBtn" 
               :loading="isLoadingNotificationBtn" 
               class="notification-btn" 
               @click="sendAllNotifications">
          <span>Notificar Todos os Signatários</span>
          <span><v-icon>mdi-chevron-right</v-icon></span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row cols="12">
      <v-col>
        <v-data-table :headers="headers" 
                     :items="signers" 
                     class="notification-table">
          <template v-slot:item.actions="{ item }">
            <v-btn :disabled="isLoadingNotificationBtn" 
                   :loading="isLoadingSingleNotificationBtn" 
                   @click="sendSignerNotification(item)">
              <v-icon color="success">
                mdi-email-fast
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:item.attributes.name="{ item }">
            {{getFirstAndLastNames(item.attributes.name)}}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NotificationsScript from "./NotificationsScript";

export default NotificationsScript;
</script>

<style scoped>
.notification-col {
  display: flex;
  justify-content: start;
}

.notification-btn {
  background-color: #00b33c;
  color: black;
  font-size: 20px;
  height: 50px;
}

.notification-table {
  width: 100%;
}
</style>